import React from 'react';
import styles from './how-it-works.module.scss';

export const HowItWorks: React.FC = () => {
  const steps = [
    {
      number: 1,
      title: 'Настройте за 15 минут',
      description:
        'Укажите услуги, добавьте сотрудников, настройте график — за 15 минут.',
      preview: '/screenshots/point-settings.png',
    },
    {
      number: 2,
      title: 'Клиенты записываются онлайн',
      description:
        'Встраиваемый виджет, VK-бот или прямая ссылка — клиент бронирует услугу за 3 клика.',
      preview: '/screenshots/customer-booking.png',
    },
    {
      number: 3,
      title: 'Управляйте с телефона',
      description:
        'Расписание, брони и выручка синхронизируются в реальном времени на всех устройствах.',
      preview: '/screenshots/day-calendar.png',
    },
  ];

  return (
    <div className={styles.how_it_works_outer}>
      <div className={styles.how_it_works}>
        <h2 className={styles.how_it_works__title}>Как это работает</h2>
        <div className={styles.how_it_works__steps}>
          {steps.map((step, i) => (
            <div key={i} className={styles.step_card}>
              <div className={styles.step__number}>{step.number}</div>
              <div className={styles.step__title}>{step.title}</div>
              <div className={styles.step__description}>{step.description}</div>
              <div className={styles.step__preview}>
                <img src={step.preview} alt={step.title} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
